import AbstractView from 'abstract';
import Vue from 'vue'
import store from 'definitions/store'
import evePaymentsInit from 'initializations/EvePayments'

export class Main extends AbstractView {
  constructor(domElementId) {
    return super(domElementId);
  }

  init() {
    evePaymentsInit.init("evePayments")

    const EvePayments = () => import(/* webpackChunkName: "eve-payments" */ 'containers/Pages/EvePayments/EvePayments')

    new Vue({
      el: "#" + this.elemId,
      store,
      render: h => h(EvePayments)
    })
  }
}
